export const URL_INVITE_CODE = "code"
export const MOBILE_BREAKPOINT = 854

// Default z-index value for chakra modal
export const DEFAULT_MODAL_Z_INDEX = 1400
// Z-index value for background modal. This has to be lower than 89, which is
// z-index value for WalletConnect modal. Thanks to that, the wallet connect
// modal will be displayed on top of the background modal.
export const BACKGROUND_MODAL_Z_INDEX = 88
export const BANNER_Z_INDEX = 40
export const LANDING_CONTAINER_WIDTH = 1440
export const MAINNET_BANNER_HEIGHT = 48
